import { useState, useEffect } from "react";
import { getDisposition } from "../api";
import DispositionCard from "./DispositionCard";
import Slider from "./Slider";
import DispositionModal from "./DispositionModal";
import useIsMobile from "../hooks/useIsMobile";

const DispositionSlide = ({ id, color, themeTitle }) => {
  const [disposition, setDisposition] = useState(null);

  useEffect(() => {
    getDisposition(id).then(setDisposition);
  }, [id]);

  return (
    <>
      {disposition !== null && (
        <DispositionCard {...disposition} color={color} hideTheme={true} themeTitle={themeTitle} slider={true} />
      )}
    </>
  );
};

const DispositionSlider = ({ dispositionIds = [], color = "blue", themeTitle = "" }) => {
  const isMobile = useIsMobile();
  return (
    <div className={`disposition-slider disposition-slider--${color}`} role="region" aria-labelledby="slider-title">
      <div className="container">
        <div className="row">
          <div className="col-1 col-l-1o3">
            <div className="ClusterDetail-title block block--xdark block--type1">
              <h2 id="slider-title">Wat zijn de maatregelen?</h2>
            </div>
          </div>
        </div>
      </div>
      <Slider color={color}>
        {dispositionIds.map((id, index) => (
          <DispositionSlide id={id} key={index} color={color} themeTitle={themeTitle} />
        ))}
      </Slider>
      {isMobile && <DispositionModal />}
    </div>
  );
};

export default DispositionSlider;
